export default __webpack_public_path__ + "static/media/phone.befc24ab.svg";